import {createApi} from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const profesorApi = createApi({
    reducerPath: "profesorApi",
    baseQuery: customFetchBase,
    tagTypes: ["Profesor"],
    endpoints: () => ({})
});
